import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { footerLinksPropType } from '../../../../propTypes';
import { Container, Title, Links, Link, LinkWrapper } from './footerLinksSection.styles';

export class FooterLinksSection extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    links: footerLinksPropType,
  };

  renderLink = ({ url, label, shouldOpenInNewTab }) => (
    <LinkWrapper key={label}>
      <Link openInternalInNewTab={shouldOpenInNewTab} to={url}>
        {label}
      </Link>
    </LinkWrapper>
  );

  render() {
    return (
      <Container className={this.props.className}>
        <Title>{this.props.title}</Title>
        <Links>{this.props.links.map(this.renderLink)}</Links>
      </Container>
    );
  }
}
